import { createFileRoute, Link } from "@tanstack/react-router";
import { MembersTable } from "@/components/MembersTable";

/**
 * /admin/users — instance role management. Gated server-side by
 * requireAdmin; the sidebar link is hidden from non-admins so most users
 * never see this page. If a member lands here directly the GET returns
 * 403 and we render an empty state via MembersTable.
 */
function AdminUsersPage() {
  return (
    <AdminShell tab="users">
      <MembersTable />
    </AdminShell>
  );
}

function AdminShell({
  tab,
  children,
}: {
  tab: "users" | "invites";
  children: React.ReactNode;
}) {
  return (
    <div className="pg-wrap" style={{ padding: "22px 30px 80px" }}>
      <div style={{ marginBottom: 20 }}>
        <h1 className="t-h1" style={{ margin: 0 }}>
          Admin
        </h1>
        <p className="t-sm" style={{ opacity: 0.7, margin: "4px 0 0" }}>
          Manage user roles and pending invites.
        </p>
      </div>
      <div
        style={{
          display: "flex",
          gap: 8,
          borderBottom: "1px solid var(--border)",
          marginBottom: 18,
        }}
      >
        <Link
          to="/admin/users"
          className={`tab${tab === "users" ? " active" : ""}`}
          style={{
            padding: "8px 14px",
            textDecoration: "none",
            color: "inherit",
            borderBottom:
              tab === "users"
                ? "2px solid var(--accent)"
                : "2px solid transparent",
            marginBottom: -1,
          }}
        >
          Users
        </Link>
        <Link
          to="/admin/invites"
          className={`tab${tab === "invites" ? " active" : ""}`}
          style={{
            padding: "8px 14px",
            textDecoration: "none",
            color: "inherit",
            borderBottom:
              tab === "invites"
                ? "2px solid var(--accent)"
                : "2px solid transparent",
            marginBottom: -1,
          }}
        >
          Invites
        </Link>
      </div>
      {children}
    </div>
  );
}

// Re-export for the invites page so both share the same shell.
export { AdminShell };

export const Route = createFileRoute("/admin/users")({
  component: AdminUsersPage,
});
